export interface PIdNameModel {
    id: number,
    name: string
}

export interface ProfilePermission extends PIdNameModel {
    code?: string
}

export interface Profile{
    id: number,
    name: string,
    email: string,
    phoneNumber: string,
    position: string,
    projects: string,
    roles: string,
    workspaceName: string,
    isAdmin: boolean,
    parts: Part[],
    permissions: ProfilePermission[]
}

export enum Part{
    'ProjectTypes'='ProjectTypes',
    'AbsenceTypes'='AbsenceTypes',
    'ShiftTypes'='ShiftTypes',
    'Roles'='Roles',
    'Employees'='Employees',
    'Clients'='Clients',
    'Projects'='Projects',
    'StartAndEndDayTime'='StartAndEndDayTime',
    'WorkCalendar'='WorkCalendar',
    'NotificationAtEndOfMonth'='NotificationAtEndOfMonth',
    'Payments'='Payments',
    'Subscription'='Subscription',
    'EarlyAccess'='EarlyAccess',
    'Integrations'='Integrations',
    'Timesheet'='Timesheet',
    'Vacation'='Vacation',
    'TagTypes'='TagTypes',
    'Cost'='Cost',
    'TimeBank'='TimeBank'
}
